import Phaser from 'phaser';
import { META_UPGRADES } from '../data.js';
import { Save } from '../save.js';

export class ShopScene extends Phaser.Scene {
  constructor() { super('Shop'); }

  create() {
    const W = this.scale.width, H = this.scale.height;
    this.save = Save.load();

    this.add.text(W / 2, 40, 'UPGRADES', {
      fontFamily: 'Courier New, monospace', fontSize: '28px', color: '#b89cff',
    }).setOrigin(0.5);

    this.creditsLabel = this.add.text(W / 2, 76, this._creditsText(), {
      fontFamily: 'Courier New, monospace', fontSize: '16px', color: '#ffd755',
    }).setOrigin(0.5);

    this.rows = [];
    const keys = Object.keys(META_UPGRADES);
    let y = 110;
    for (const k of keys) {
      this._makeRow(k, 24, y, W - 48);
      y += 50;
    }

    const back = this.add.text(W / 2, H - 36, '< BACK TO MENU', {
      fontFamily: 'Courier New, monospace', fontSize: '16px',
      color: '#e8e8ff', backgroundColor: '#1a1430', padding: { x: 12, y: 6 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    back.on('pointerdown', () => this.scene.start('Menu'));
    this.input.keyboard.on('keydown-ESC', () => this.scene.start('Menu'));
  }

  _creditsText() { return 'credits: ' + this.save.credits + 'c'; }

  _makeRow(key, x, y, w) {
    const def = META_UPGRADES[key];
    const lvl = this.save.meta[key] || 0;
    const maxed = lvl >= def.maxLevel;
    const nextLvl = lvl + 1;
    const cost = maxed ? 0 : def.cost(nextLvl);
    const affordable = !maxed && this.save.credits >= cost;

    const bg = this.add.rectangle(x + w / 2, y + 20, w, 44, 0x141430, 0.85)
      .setStrokeStyle(2, maxed ? 0x66ddaa : (affordable ? 0xb89cff : 0x3a2f5a));

    const name = this.add.text(x + 12, y + 6, def.name, {
      fontFamily: 'Courier New, monospace', fontSize: '14px', color: '#e8e8ff',
    });
    const desc = this.add.text(x + 12, y + 24, def.desc(nextLvl) + (maxed ? '  (MAX)' : ''), {
      fontFamily: 'Courier New, monospace', fontSize: '11px', color: '#aab',
    });
    const lvlBadge = this.add.text(x + w - 130, y + 14, `lvl ${lvl}/${def.maxLevel}`, {
      fontFamily: 'Courier New, monospace', fontSize: '12px', color: '#778',
    });
    const btnText = maxed ? 'MAX' : `${cost}c`;
    const btn = this.add.text(x + w - 50, y + 14, btnText, {
      fontFamily: 'Courier New, monospace', fontSize: '14px',
      color: maxed ? '#66ddaa' : (affordable ? '#ffd755' : '#665'),
      backgroundColor: maxed ? '#142a22' : (affordable ? '#33256a' : '#1a1a28'),
      padding: { x: 8, y: 4 },
    });
    if (!maxed && affordable) {
      btn.setInteractive({ useHandCursor: true });
      btn.on('pointerdown', () => this._buy(key));
    }
    this.rows.push({ key, bg, name, desc, lvlBadge, btn });
  }

  _buy(key) {
    const def = META_UPGRADES[key];
    const lvl = this.save.meta[key] || 0;
    if (lvl >= def.maxLevel) return;
    const cost = def.cost(lvl + 1);
    if (this.save.credits < cost) return;
    this.save.credits -= cost;
    this.save.meta[key] = lvl + 1;
    Save.write(this.save);
    for (const r of this.rows) {
      r.bg.destroy(); r.name.destroy(); r.desc.destroy(); r.lvlBadge.destroy(); r.btn.destroy();
    }
    this.rows = [];
    this.creditsLabel.setText(this._creditsText());
    const keys = Object.keys(META_UPGRADES);
    let y = 110;
    for (const k of keys) {
      this._makeRow(k, 24, y, this.scale.width - 48);
      y += 50;
    }
  }
}
